import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/UI";
import { MedStock } from "./medicines/MedStock";
import { MedProtocols } from "./medicines/MedProtocols";
import { SemenStock } from "./medicines/SemenStock";
import { MedCounts } from "./medicines/MedCounts";
import { MedUsage } from "./medicines/MedUsage";
import { MedStats } from "./medicines/MedStats";

export default function Medicines() {
  const [sp] = useSearchParams();
  const tab = sp.get("t") || "stock";
  return (
    <div data-testid="medicines-page">
      <PageHeader title="İlaç Yönetimi" subtitle="İlaç stoğu, tedavi protokolleri, sperma stoğu, günlük kullanım kaydı ve istatistikler." />
      {tab === "stock" && <MedStock />}
      {tab === "protocols" && <MedProtocols />}
      {tab === "semen" && <SemenStock />}
      {tab === "counts" && <MedCounts />}
      {tab === "usage" && <MedUsage />}
      {tab === "stats" && <MedStats />}
    </div>
  );
}
